import { PropertyValue } from "./property-value";

export class MetaDataValue {
    public __classname__: string = 'MetaDataValue';
    
    public Property : string;
	public Values : string[] | null;
	public PropertyValues : PropertyValue[] | null;

    constructor(params : MetaDataValueNamedParameters) {
        this.Property = params.Property;
        this.Values = params.Values ?? null;
        this.PropertyValues = params.PropertyValues ?? null;
    }
}

export interface MetaDataValueNamedParameters {
    Property: string,
    Values?: string[],
    PropertyValues?: PropertyValue[]
}